import rewardType from "./infractionTypes";

const initialState = {
  isLoading: false,
  filtering: false,
  allInfractions: { data: [] },
  allInfractionsNoPagination: {},
  searching: false,
  search: [],
  singleInfraction: {},

  approving: false,
  downloading: false,
  updating: false,
  deleting: false,
  myReward: {},
};

export default function infractionReducer(state = initialState, action) {
  switch (action.type) {
    case rewardType.LOADING_INFRACTIONS:
      return {
        ...state,
        isLoading: action.payLoad,
      };

    // case rewardType.DOWNLOADING:
    //   return {
    //     ...state,
    //     downloading: action.payLoad,
    //   };

    case rewardType.UPDATING:
      return {
        ...state,
        updating: action.payLoad,
      };

    case rewardType.ALL_INFRACTIONS:
      let newData = {};
      if (action.payLoad?.data === undefined) {
        newData = {};
      } else {
        newData = action.payLoad?.data;
      }
      return {
        ...state,
        allInfractions: newData,
      };

    case rewardType.SINGLE_INFRACTION:
      return {
        ...state,
        singleInfraction: action.payLoad?.data,
      };

    // case rewardType.GET_MY_REWARD:
    //   return {
    //     ...state,
    //     myReward: action.payLoad?.data,
    //   };

    case rewardType.STORE_INFRACTION:
      const prevInfraction = state?.allInfractions;
      let newInfraction;
      if (prevInfraction?.data?.length > 0) {
        newInfraction = {
          ...state.allInfractions,
          data: [...state.allInfractions?.data, action.payLoad?.data],
        };
      } else {
        newInfraction = action.payLoad?.data;
      }
      return {
        ...state,
        allInfractions: newInfraction,
      };

    // case rewardType.APPROVING_REWARD:
    //   return {
    //     ...state,
    //     approving: action.payLoad,
    //   };

    // case rewardType.APPROVE_REWARD_MANAGEMENT:
    //   let approved = {
    //     ...state.singleReward,
    //     management_approved: true,
    //   };
    //   return {
    //     ...state,
    //     singleReward: approved,
    //   };

    // case rewardType.UNAPPROVE_REWARD_MANAGEMENT:
    //   let unapproved = {
    //     ...state.singleReward,
    //     management_approved: false,
    //   };
    //   return {
    //     ...state,
    //     singleReward: unapproved,
    //   };

    // case rewardType.CLAIM_REWARD:
    //   let claimed = {
    //     ...state.singleReward,
    //     management_approved: false,
    //   };
    //   return {
    //     ...state,
    //     singleReward: claimed,
    //   };

    case rewardType.SEARCHING:
      return {
        ...state,
        searching: action.payLoad,
      };

    case rewardType.SEARCH_INFRACTIONS:
      return {
        ...state,
        search: action.payLoad?.data,
      };

    case rewardType.FILTERING_INFRACTIONS:
      return {
        ...state,
        filtering: action.payLoad,
      };

    case rewardType.FILTER_INFRACTIONS:
      return {
        ...state,
        allInfractions: action.payLoad?.data,
      };

    // case rewardType.ALL_REWARDS_NO_PAGINATION:
    //   return {
    //     ...state,
    //     allRewardsNoPagination: action.payLoad?.data,
    //   };

    // case rewardType.DELETING_FOOD:
    //   return {
    //     ...state,
    //     deleting: action.payLoad,
    //   };

    default:
      return state;
  }
}
